export const AUCUN = 'Aucun';
export const GROUPE = 'Groupe';
export const ENSEIGNE = 'Enseigne';
export const POINT_VENTE = 'PointVente';

export const SOUS_TYPE_AUCUN = 'Aucun';
export const SOUS_TYPE_CONCURRENT = 'Concurrent';
export const TYPE_CLIENT = 'Client';
export const GUID_VIDE = '00000000-0000-0000-0000-000000000000';
